import React from 'react';
import { Brain, Network, Database, Rocket } from 'lucide-react';
import { courseData } from '../mockData';

const iconMap = {
  brain: Brain,
  network: Network,
  database: Database,
  rocket: Rocket
};

const Features = () => {
  return (
    <section className="py-20 bg-section">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="heading-1 mb-4">What Makes This Course Unique</h2>
          <p className="body-large text-secondary max-w-2xl mx-auto">
            Learn the frameworks and techniques that power reliable, production-ready AI systems
          </p>
        </div>

        <div className="voice-grid">
          {courseData.features.map((feature) => {
            const Icon = iconMap[feature.icon];
            return (
              <div key={feature.id} className="voice-card accent-purple hover-lift">
                <div className="w-16 h-16 rounded-2xl bg-accent-purple-400 text-white flex items-center justify-center mb-6">
                  <Icon className="w-8 h-8" />
                </div>
                <h3 className="voice-card-title">{feature.title}</h3>
                <p className="voice-card-description">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
